// @ts-expect-error
import 'swiper/css';

import StarIcon from '@mui/icons-material/Star';
import { EffectCoverflow } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { makeStyles } from 'tss-react/mui';

import { SIZES } from '../../assets/constants/constants';
import Typography from '../Typography';

const useStyles = makeStyles()(({ breakpoints, palette, spacing }) => ({
  carouselContainer: {
    width: '100%',
    // cardContent
    '& .swiper-slide-prev > div > div': {
      backgroundColor: palette.background.default,
      // stars
      '& svg': {
        color: palette.secondary.main,
      },
    },
    '& .swiper-slide-next > div > div': {
      backgroundColor: palette.background.default,
      '& svg': {
        color: palette.secondary.main,
      },
    },

    [breakpoints.up('xl')]: {
      maxWidth: SIZES.layout.width.lg,

      '& .swiper::before': {
        content: '""',
        boxShadow: `0px 0px 6rem 10rem ${palette.background.contrast}`,
        display: 'block',
        zIndex: 1000,
        position: 'absolute',
        bottom: 0,
        top: 0,
        left: '-2rem',
      },
      '& .swiper::after': {
        content: '""',
        boxShadow: `0px 0px 6rem 10rem ${palette.background.contrast}`,
        display: 'block',
        zIndex: 1000,
        position: 'absolute',
        bottom: 0,
        top: 0,
        right: '-2rem',
      },
    },
  },
  cardContainer: {
    width: '100%',
    height: '100%',
    color: palette.text.default,
    display: 'flex',
  },
  cardContent: {
    borderRadius: 5,
    textAlign: 'center',
    minHeight: 200,
    width: '100%',
    backgroundColor: palette.background.light,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: spacing(2),
    padding: spacing(1.5),
    [breakpoints.up('sm')]: {
      padding: spacing(3),
    },
  },
  starsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: spacing(3),
  },
  star: {
    color: palette.common.white,
    fontSize: '1.2rem',
    [breakpoints.up('sm')]: {
      margin: spacing(0, 0.5),
      fontSize: '2rem',
    },
  },
  name: {
    marginTop: spacing(1.5),
  },
}));

const cardsRaw = [
  {
    date: 'april 2024',
    name: 'NN',
    stars: 5,
    text: 'Bedre, raskere og enklere enn jeg trodde, god og rask telefon service også. Søkte i mars 2024 og landet nytt billigere lån på en uke. Betaler ca 1.000 kr mindre pr md og sparer ca 30.000 totalt.',
  },
  {
    date: 'april 2024',
    name: 'Heidi Djupdal',
    stars: 5,
    text: 'God service og rask tilbakemelding! Så fornøyd med å få hjelp til å få info om bedre lånetilbud med mye lavere rente, og dermed få mindre utgifter hver måned, dere er supre😄👌',
  },
  {
    date: 'april 2024',
    name: 'Roar Simonsen',
    stars: 5,
    text: 'Det er bare å si at alt gikk enkelt og greit med å få ordnet det jeg hadde behov  for her. Godt fornøyd med behandlingen og god service.',
  },
  {
    date: 'april 2024',
    name: 'Nino Olsen',
    stars: 5,
    text: 'Forløpig veldig fornøyd, rask saksbehandling  og sparte penger ved å refinansiere.',
  },
  {
    date: 'mars 2024',
    name: 'Helge Pettersen',
    stars: 5,
    text: 'Enkelt, greit, lettvint og lavere rente enn hva jeg fikk på egen henvendelse',
  },
];

// Make enough slides for loop to work
const cards = [...cardsRaw, ...cardsRaw];

const Testimonials = () => {
  const { classes } = useStyles();

  if (!cards) return null;

  return (
    <div className={classes.carouselContainer}>
      <Swiper
        modules={[EffectCoverflow]}
        grabCursor
        centeredSlides
        loop
        slidesPerView={2}
        effect="coverflow"
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 150,
          modifier: 1,
          slideShadows: false,
        }}
        breakpoints={{
          600: {
            slidesPerView: 2,
            coverflowEffect: { stretch: -40, depth: 200 },
          },
          960: {
            slidesPerView: 3,
            coverflowEffect: { stretch: -60 },
          },
          1060: {
            slidesPerView: 4,
            spaceBetween: 10,
            coverflowEffect: { stretch: -120 },
          },
        }}
      >
        {cards
          .map((i) => {
            const parts = i.date.split('/');
            return {
              ...i,
              transformedDate: `${parts[2]}-${parts[1]}-${parts[0]}`,
            };
          })
          .sort(
            (a, b) =>
              new Date(b.transformedDate).getTime() -
              new Date(a.transformedDate).getTime(),
          )
          .map((item, index) => (
            <SwiperSlide key={item.text + index}>
              <div className={classes.cardContainer}>
                <div className={classes.cardContent}>
                  {item.stars > 0 ? (
                    <div className={classes.starsContainer}>
                      {Array.from(Array(item.stars), (_, i) => (
                        <StarIcon key={i} className={classes.star} />
                      ))}
                    </div>
                  ) : null}
                  <span>
                    {/* @ts-ignore */}
                    <Typography variant="subtitle2" component="p">
                      {item.text}
                    </Typography>
                    {/* @ts-ignore */}
                    <Typography
                      variant="subtitle2Bold"
                      className={classes.name}
                    >
                      {item.name}, {item.date}
                    </Typography>
                  </span>
                </div>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default Testimonials;
